var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi--cancel 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0013 1.66699C14.5846 1.66699 18.3346 5.41699 18.3346 10.0003C18.3346 14.5837 14.5846 18.3337 10.0013 18.3337C5.41797 18.3337 1.66797 14.5837 1.66797 10.0003C1.66797 5.41699 5.41797 1.66699 10.0013 1.66699ZM10.0013 3.33366C8.41797 3.33366 7.0013 3.83366 5.91797 4.75033L15.2513 14.0837C16.0846 12.917 16.668 11.5003 16.668 10.0003C16.668 6.33366 13.668 3.33366 10.0013 3.33366ZM14.0846 15.2503L4.7513 5.91699C3.83464 7.00033 3.33464 8.41699 3.33464 10.0003C3.33464 13.667 6.33464 16.667 10.0013 16.667C11.5846 16.667 13.0013 16.167 14.0846 15.2503Z",
    fill: "#263141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevoke);
export default __webpack_public_path__ + "static/media/revoke.973d46e81f413d9defa5bc3fc15985e4.svg";
export { ForwardRef as ReactComponent };